module.exports = __webpack_public_path__ + "img/__bg.6a4c4ee0.jpg";